import styled from 'styled-components';

const NavigationRowText = styled.span`
  font-family: 'Avenir', 'Arial', sans-serif;
  font-size: 15px;
`;

const NavigationRowWrapper = styled.div`
  border-bottom: 1px solid #cccccc;
  height: 50px;
  display: flex;
  padding-left: 12px;
  align-items: center;
  position: relative;
  font-weight: 300;
  text-transform: ${({ capitalize }) => (capitalize ? 'capitalize' : 'uppercase')};
  color: ${({ red }) => (red ? '#F25C5E' : '#000000')};
  ${({ backRow }) =>
    backRow
      ? 'background-color: rgb(153, 153, 153); color: white; font-weight: bold; text-transform: capitalize;'
      : null}
`;

export { NavigationRowText, NavigationRowWrapper };
